import { render, staticRenderFns } from "./CommodityList.vue?vue&type=template&id=032865a4&scoped=true"
import script from "./CommodityList.vue?vue&type=script&lang=js"
export * from "./CommodityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032865a4",
  null
  
)

export default component.exports